export default [
    {
        path: '',
        component: () => import('../views/teams/Teams'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-discount',
            title: 'Список бригад',
            altNavSubMenuActive:'/teams/index',
        },
        children: [
            {
                path: '/(uk/|ru/)?/teams/index',
                name: 'TeamsList',
                component: () => import('../views/teams/tables/TeamList'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-discount',
                    title: 'Бригады',
                },
            }, {
                path: '/(uk/|ru/)?/teams/top',
                name: 'TeamTop',
                component: () => import('../views/teams/tables/TeamTop'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-discount',
                    title: 'Бригады',
                },
            }
        ]
    }, {
        path: '/(uk/|ru/)?/teams/users',
        component: () => import('../views/teams/TeamEdit'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-discount',
            altNavSubMenuActive:'/teams/index',
        },
        children: [
            {
                path: '',
                name: 'TeamUsers',
                component: () => import('../views/teams/tables/TeamUsers'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-discount',
                    altNavSubMenuActive:'/teams/index',
                    title: 'Бригады',
                },
            }, {
                path: '/(uk/|ru/)?/teams/history',
                name: 'TeamHistory',
                component: () => import('../views/teams/tables/TeamHistory'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-discount',
                    altNavSubMenuActive:'/teams/index',
                    title: 'Бригады',
                },
            }, {
                path: '/(uk/|ru/)?/teams/history/detail',
                name: 'TeamHistoryDetail',
                component: () => import('../views/teams/tables/TeamHistoryDetail'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-discount',
                    altNavSubMenuActive:'/teams/index',
                    title: 'Бригады',
                },
            }, {
                path: '/(uk/|ru/)?/teams/balance',
                name: 'TeamHistoryBalance',
                component: () => import('../views/teams/tables/TeamHistoryBalance'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-discount',
                    altNavSubMenuActive:'/teams/index',
                    title: 'Бригады',
                },
            }, {
                path: '/(uk/|ru/)?/teams/payRequest',
                name: 'TeamPayRequest',
                component: () => import('../views/teams/tables/TeamPayRequest'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-discount',
                    altNavSubMenuActive:'/teams/index',
                    title: 'Бригады',
                },
            }, {
                path: '/(uk/|ru/)?/teams/candidates',
                name: 'TeamCandidates',
                component: () => import('../views/teams/tables/TeamCandidates'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-discount',
                    altNavSubMenuActive:'/teams/index',
                    title: 'Бригады',
                },
            }, {
                path: '/(uk/|ru/)?/teams/summary',
                name: 'TeamSummary',
                component: () => import('../views/teams/tables/TeamSummary'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-discount',
                    altNavSubMenuActive:'/teams/index',
                    title: 'Бригады',
                },
            },
        ]
    }, {
        path: '/(uk/|ru/)?/sms/index',
        name: 'SMSlist',
        component: () => import('../views/sms/SMSlist'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-mobile',
            title: 'Список СМС'
        }
    },
]
